import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CandidacyPlacement, HttpResponse } from "@/types";

export function useDeletePlacement() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({ placementId }: { placementId: number }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/placements/${placementId.toString()}`;
      const res = await guacHttpClient.delete<
        CandidacyPlacement,
        HttpResponse<CandidacyPlacement>
      >(path);

      return res.data;
    },
  });

  return mutation;
}
